import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHomeSrWrapper',
  props: {
    isListCreative: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})